import { Component } from '@angular/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';

@Component({
    selector: 'app-blwch-gwag',
    templateUrl: './blwch-gwag.component.html',
    styleUrls: ['./blwch-gwag.component.scss']
})
export class BlwchGwagComponent extends FieldType<FieldTypeConfig> {

}
